import { useQuery } from 'react-query';
import apiUrl from 'common/api-url';
import * as api from 'reduxStore/apiService';

export interface PosStatusResponse {
  openDay: string | null;
  lastClosedDay: string | null;
}

/*
 * Fails open by design (THY-2081): when the request errors or hasn't resolved
 * yet, `lastClosedDay` is null and the fiscal-day-closure cancellation check
 * simply doesn't block.
 */
export function usePosStatusQuery(enabled: boolean) {
  const { isLoading, data } = useQuery<PosStatusResponse>(
    ['pos-status'],
    () => api.get<PosStatusResponse>(apiUrl('POS_STATUS')),
    {
      enabled,
    },
  );

  return { isLoading, lastClosedDay: data?.lastClosedDay ?? null };
}
